import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=55ae11c8&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae11c8",
  null
  
)

export default component.exports